import React from 'react';
import type { PopularFacetsFragment } from 'src/types';
import { PopularFacetsSection } from './popular-facets-section';

type Props = {
  popularFacets: PopularFacetsFragment['popularFacets'];
};
/// make loadable
const PopularFacetsSections = ({ popularFacets }: Props) => {
  return (
    <>
      {popularFacets.map(popularFacet => (
        <PopularFacetsSection key={popularFacet.url} {...popularFacet} />
      ))}
    </>
  );
};
export default PopularFacetsSections;
